import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=507bf1ac&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=ts"
export * from "./Captcha.vue?vue&type=script&lang=ts"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=507bf1ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507bf1ac",
  null
  
)

export default component.exports